import React from "react";

import { Spacing } from "@sicredi/react";
import { AppearanceProps } from "@sicredi/react/dist/spacing/Spacing";

type ResponsiveSpacingProps = {
  appearanceMobile?: AppearanceProps["appearance"];
  appearanceDesktop?: AppearanceProps["appearance"];
};

export const ResponsiveSpacing: React.FC<ResponsiveSpacingProps> = ({
  appearanceDesktop = "medium",
  appearanceMobile = "small",
}) => {
  return (
    <>
      <Spacing appearance={appearanceMobile} className="show-mobile" />
      <Spacing appearance={appearanceDesktop} className="hide-mobile" />
    </>
  );
};

export default ResponsiveSpacing;
